export default "__VITE_ASSET__EAfJbIbD__"